export default "__VITE_ASSET__CIQXHE9S__"